import { c as _c } from "react/compiler-runtime";
export const CruzTm = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>Cruz<sup className="pb-1 text-[7px]">TM</sup></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};